import{jsx as r}from"react/jsx-runtime";import{lazy as t,Suspense as i}from"react";const n=t((()=>import("./VisualEditing.js")));function o(t){return r(i,{fallback:null,children:r(n,{...t})})}export{o as VisualEditing};
//# sourceMappingURL=index.js.map
